export default {
  CURRENT_PAGE: 1,
  PAGE_SIZE: 10,
};
